module.exports = __webpack_public_path__ + "06fae16a3c5ac7ac1f88aa0ff698a096.png";